import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import IconVisibilityOff from '@mui/icons-material/VisibilityOffOutlined';
import IconVisibilityOn from '@mui/icons-material/VisibilityOutlined';
import { Button, Divider, IconButton, Link, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LoginModel } from '~/models/model.auth';
import { ROUTES } from '~/routes/routes';
import { AuthService } from '~/services/service.auth';
import { useService } from '~/services/service.base';
import { useFormikModel } from '~/tools/formik.model';
import { plainToModel } from '~/tools/plain.model';
import { Column, Row } from '~/views/atoms/boxes';
import { FormikFieldText } from '~/views/atoms/formik.text';
import { PageWrapper } from '~/views/organisms/wrapper.page';
import { validatorLogin } from '~/pages/login/validator.login';
export const PageLogin = observer(() => {
    const { t } = useTranslation();
    const auth = useService(AuthService);
    const nav = useNavigate();
    const initialValues = useMemo(() => plainToModel(LoginModel, {}), []);
    const onSubmit = useCallback(async (data) => {
        await auth.login(data);
        if (auth.isLogged) {
            nav(ROUTES.FUNDS.path);
        }
    }, [auth, nav]);
    const formik = useFormikModel(LoginModel, {
        initialValues,
        onSubmit,
        validate: validatorLogin,
        initialTouched: { email: false, password: false },
        validateOnChange: true,
        validateOnMount: true,
    });
    const passwordProps = useMemo(() => ({
        type: auth.openPassSvc.open ? 'text' : 'password',
        InputProps: {
            endAdornment: (_jsx(IconButton, { onClick: auth.openPassSvc.handleToggle, children: auth.openPassSvc.open ? _jsx(IconVisibilityOn, {}) : _jsx(IconVisibilityOff, {}) })),
        },
    }), [auth.openPassSvc.handleToggle, auth.openPassSvc.open]);
    return (_jsx(PageWrapper, { children: _jsxs(Column, { p: 2, marginTop: 2.5, flex: 1, justifyContent: "space-between", children: [_jsxs(Column, { flex: 1, gap: 2, justifyContent: "flex-start", children: [_jsx(FormikFieldText, { formikProps: formik, name: "email", placeholder: t('LOGIN_EMAIL_PLACEHOLDER'), onBlur: event => formik.getFieldProps('email').onBlur(event) }), _jsx(FormikFieldText, { formikProps: formik, name: "password", ...passwordProps, placeholder: t('LOGIN_PASSWORD_PLACEHOLDER'), onBlur: event => formik.getFieldProps('password').onBlur(event) }), _jsx(Row, { children: _jsx(Link, { href: auth.serviceConfig.restorePasswordUrl, children: t('LOGIN_BTN_FORGOT_PASSWORD') }) }), _jsx(Divider, {}), _jsx(Row, { mb: 2.5, children: _jsxs(Column, { children: [_jsx(Typography, { children: t('LOGIN_NOT_MEMEBER') }), _jsx(Link, { href: auth.serviceConfig.registerUserUrl, children: t('LOGIN_BTN_BECOME_MEMBER') })] }) })] }), _jsx(Button, { variant: "contained", size: "large", disabled: !formik.isValid, onClick: formik.submitForm, children: t('LOGIN_BTN_LOGIN') })] }) }));
});
